var icon = require('vue-svgicon')
icon.register({
  'ks-icon-personnel-type': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64 22a21 21 0 1 1-21 21 21 21 0 0 1 21-21m0 52.5c23.21 0 42 9.4 42 21V106H22V95.5c0-11.6 18.79-21 42-21z"/>'
  }
})
